var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("参与规则设置")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活动期间每人共可参与",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 12 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["totalJoinNum", _vm.rules.totalJoinNum],
                            expression: "['totalJoinNum',rules.totalJoinNum]",
                          },
                        ],
                        attrs: { min: 1, max: 10000 },
                      }),
                      _c("span", { staticClass: "times" }, [_vm._v("次奖")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活动期间每人每日可参与",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 12 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["dayJoinNum", _vm.rules.dayJoinNum],
                            expression: "['dayJoinNum',rules.dayJoinNum]",
                          },
                        ],
                        attrs: { min: 1, max: 10000 },
                      }),
                      _c("span", { staticClass: "times" }, [_vm._v("次奖")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活动期间每人可中",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 12 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["winNum", _vm.rules.winNum],
                            expression: "['winNum',rules.winNum]",
                          },
                        ],
                        attrs: { min: 1, max: 10000 },
                      }),
                      _c("span", { staticClass: "times" }, [_vm._v("次奖")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活动期间每人每日分享增加抽奖",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 12 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["shareAddTimes", _vm.rules.shareAddTimes],
                            expression: "['shareAddTimes',rules.shareAddTimes]",
                          },
                        ],
                        attrs: { min: 1, max: 10000 },
                      }),
                      _c("span", { staticClass: "times" }, [_vm._v("次奖")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "活动期间每人总分享增加抽奖",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 12 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "shareAddTotalTimes",
                              _vm.rules.shareAddTotalTimes,
                            ],
                            expression:
                              "['shareAddTotalTimes',rules.shareAddTotalTimes]",
                          },
                        ],
                        attrs: { min: 1, max: 10000 },
                      }),
                      _c("span", { staticClass: "times" }, [_vm._v("次奖")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("参与标签设置")]),
          _c(
            "div",
            [
              _vm._v("标签规则 "),
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.add(0)
                    },
                  },
                },
                [_vm._v("添加规则")]
              ),
            ],
            1
          ),
          _vm._l(_vm.tagRuleList, function (item, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAutoTag,
                    expression: "isAutoTag",
                  },
                ],
                key: item.tagRuleId,
              },
              [
                _c(
                  "div",
                  { staticClass: "rule-item" },
                  [
                    _c("h3", [_vm._v("微信用户:")]),
                    _c("a-select", {
                      staticStyle: { width: "200px" },
                      attrs: { options: _vm.ruleTypeOptions },
                      model: {
                        value: item.ruleId,
                        callback: function ($$v) {
                          _vm.$set(item, "ruleId", $$v)
                        },
                        expression: "item.ruleId",
                      },
                    }),
                    [_c("span", [_vm._v("时")])],
                    _c("tagPicker", {
                      staticStyle: { width: "300px" },
                      model: {
                        value: item.tagId,
                        callback: function ($$v) {
                          _vm.$set(item, "tagId", $$v)
                        },
                        expression: "item.tagId",
                      },
                    }),
                    _c("a-icon", {
                      attrs: { type: "plus-circle" },
                      on: {
                        click: function ($event) {
                          return _vm.add(index)
                        },
                      },
                    }),
                    _c("a-icon", {
                      attrs: { type: "minus-circle" },
                      on: {
                        click: function ($event) {
                          return _vm.delItem(index)
                        },
                      },
                    }),
                  ],
                  2
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c("a-button", { on: { click: _vm.lastStep } }, [_vm._v("上一步")]),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save()
                },
              },
            },
            [_vm._v("下一步")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }